<template>
  <div class="login">
    <div class="login-brand">
      <div class="logo">鲸</div>
      <h1>鲸迹·知行</h1>
      <p>医药代表 AI 行为管理系统</p>
      <div class="feature">AI 合规护航 · 行为全程留痕 · 人工最终确认</div>
    </div>
    <el-card class="login-card">
      <h2>欢迎登录</h2>
      <p class="muted">使用组织账号进入管理后台</p>
      <el-form ref="form" :model="form" :rules="rules" autocomplete="off" @keyup.enter.native="submit">
        <el-form-item prop="login_name"><el-input v-model.trim="form.login_name" prefix-icon="el-icon-user" name="pc-login-name" autocomplete="off" placeholder="账号" /></el-form-item>
        <el-form-item prop="password"><el-input v-model="form.password" prefix-icon="el-icon-lock" type="password" show-password name="pc-login-password" autocomplete="new-password" placeholder="密码" /></el-form-item>
        <el-button type="primary" :loading="loading" class="submit" @click="submit">登录</el-button>
      </el-form>
    </el-card>
  </div>
</template>
<script>
export default {
  data: () => ({
    loading: false,
    form: { login_name: '', password: '' },
    rules: { login_name: [{ required: true, message: '请输入账号', trigger: 'blur' }], password: [{ required: true, message: '请输入密码', trigger: 'blur' }] }
  }),
  methods: {
    submit () {
      if (this.loading) return
      this.$refs.form.validate(async valid => {
        if (!valid || this.loading) return
        this.loading = true
        try { const result = await this.$store.dispatch('login', this.form); this.form.password = ''; this.$router.replace(result.user.password_change_required ? '/change-password' : '/') }
        catch (e) { this.$message.error(e.message) } finally { this.loading = false }
      })
    }
  }
}
</script>
<style scoped>
.login{height:100%;display:flex;align-items:center;justify-content:center;gap:120px;background:linear-gradient(135deg,#063e62,#0c82ba 56%,#eef6f9 56%)}.login-brand{color:#fff;width:390px}.logo{width:92px;height:92px;border-radius:24px;background:#fff;color:#087bb7;display:flex;align-items:center;justify-content:center;font-size:50px;font-weight:800;box-shadow:0 16px 40px rgba(0,0,0,.16)}h1{font-size:42px;margin:24px 0 8px;letter-spacing:5px}.login-brand p{font-size:18px;color:#d4edf8}.feature{margin-top:38px;border-top:1px solid rgba(255,255,255,.25);padding-top:24px;color:#c8e8f6}.login-card{width:410px;border-radius:14px;padding:20px 22px;box-shadow:0 24px 70px rgba(4,48,72,.2)}h2{margin-bottom:7px}.login-card .muted{margin-bottom:28px}.submit{width:100%;height:44px}
</style>
